module.exports = __webpack_public_path__ + "img/1.d5050b26.png";